import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import getProp from '~/lib/get-prop';
import { extrasDefinitionType } from './types';

const Wrapper = styled.div``;
const Title = styled.h4``;
const FlexTable = styled.div`
  display: flex;
  flex-direction: column;
`;
const FlexRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 5px 0;
`;
const Item = styled.div`
  flex: 1;
  font-size: 1.1rem;
`;

function Extras({ extras, definition }) {
  if (!definition) return null;
  return (
    <Wrapper>
      <Title>{definition.title}</Title>

      <FlexTable>
        {definition.lineItems.map(item => {
          const value = item.renderFunc
            ? item.renderFunc(getProp(item.key, extras), extras)
            : getProp(item.key, extras);
          if (!value) return null;
          return (
            <FlexRow key={item.key}>
              <Item>{item.label}</Item>
              <Item>{value}</Item>
            </FlexRow>
          );
        })}
      </FlexTable>
    </Wrapper>
  );
}

Extras.propTypes = {
  extras: PropTypes.object,
  definition: extrasDefinitionType,
};

export default Extras;
